import { Attrs, MinzeElement, Reactive } from 'minze'
import MainModule from '../../modules/main'

interface AuthStatusEvent {
  isLoggedIn: boolean
}

export interface LvcAuthWrapper {
  isLoggedIn: boolean
  isPartner: boolean
}

export class LvcAuthWrapper extends MinzeElement {
  attrs: Attrs = [['has-completed-profile']]
  _authHandler: any = null
  _initialized: boolean = false
  reactive: Reactive = [['isLoggedIn', false]]

  html() {
    if (!this._initialized) {
      return `<div></div>`
    }

    if (this.isLoggedIn && this.isPartner) {
      return `
      <div>
        <slot name="auth"></slot>
        <slot name="partner"></slot>
      </div>
      `
    }

    if (this.isLoggedIn) {
      return `<div><slot name="auth"></slot></div>`
    }

    return `<div><slot name="unauth"></slot></div>`
  }

  onStart(): void | Promise<void> {
    let mainModule = MainModule.getInstance()
    this._authHandler = this.handleAuthChanged.bind(this)
    mainModule.getEE().on('lvc:user_state_changed', this._authHandler)
  }

  onDestroy(): void {
    let mainModule = MainModule.getInstance()
    mainModule.getEE().off('lvc:user_state_changed', this._authHandler)
  }

  async onReady() {
    let mainModule = MainModule.getInstance()
    if (mainModule.getAuth().isLoggedIn()) {
      let user = await mainModule.getAuth().getUserData()

      await this.handleAuthChanged({
        isLoggedIn: true,
        user: user,
      })
    }
  }

  handleAuthChanged = async (data: any) => {
    let mainModule = MainModule.getInstance()

    this.isLoggedIn = data?.isLoggedIn
    this.isPartner = await mainModule.getAuth().isPartner()
    // we check first if the user has seen the popup before
    this.hasSeenCompleteProfilePopup =
      sessionStorage.getItem('hasSeenCompleteProfilePopup') === 'true'
    // if not, check to see if he completed his profile
    if (!this.hasSeenCompleteProfilePopup) {
      this.hasCompletedProfile = await mainModule.getAuth().isProfileCompleted()
    }
    this._initialized = true

    this.rerender()
  }

  css = () => `
    :host {

    }
  `
}
